module.exports = __webpack_public_path__ + "img/Training-Sel.b2fd19d6.svg";